<button [ertPermission]="'createAlert'" mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openDialog($event)">
    <mat-icon>add_alert</mat-icon>
    <span>Add Alert</span>
  </button>
</mat-menu>
